import React, { useState, useEffect, useContext, useReducer } from "react";
import { TableHeader } from "../../components/table/TableHeader";
import SliderRangleDual from "../../components/slider-range/SliderRangeDual";
import Utils from "../../utils/Utils";
import { useAuth, logout } from "../../components/auth";
import Percentile from "../../components/percentile/Percentile";
import "react-datepicker/dist/react-datepicker.css";
import LoadingSkeleton from "../../components/animations/LoadingSkeleton";
import TableSkeleton from "../../components/table/TableSkeleton";
import { useRouter } from "next/router";
import { authGetRequest } from "../../utils/authGetRequest";
import { AppContext } from "../../context/state";
import { PLAYLOG, finalScoreHeader } from "./data";
import Link from "next/link";
import NotFound from "../../components/404/NotFound";
import Head from "next/head";
import { useCookies } from "react-cookie";
import Image from "next/image";
import TableData from "../../components/table-templates/TableData";
import BoxScores from "../../components/gamePage/BoxScores";
import { TableRow } from "../../components/table-templates/TableData";
import { getDefYear } from "../../constants/main";
import { SIGNUPS_CLOSED_MESSAGE } from "../../constants/main";
const gameLogHeader = [
  {
    title: "Player",
    showImage: false,
    sortable: true,
    key: "player",
    classList: ["shrink-column"],
  },
  {
    title: "PTS",
    showImage: false,
    sortable: true,
    key: "pts",
    classList: ["shrink-column"],
    teamStats: true,
  },
  {
    title: "SQ PTS",
    showImage: false,
    sortable: true,
    key: "sq_pts",
    classList: ["shrink-column"],
    teamStats: true,
  },
  {
    title: "PTS Regression",
    showImage: false,
    sortable: false,
    key: "pts_regression",
    classList: ["shrink-column"],
    showArrow: true,
    teamStats: true,
  },
  {
    title: "FG",
    showImage: false,
    sortable: true,
    key: "fg_makes",
    classList: ["shrink-column"],
    teamStats: true,
  },
  {
    title: "FGA",
    showImage: false,
    sortable: true,
    key: "fg_attempts",
    classList: ["shrink-column"],
    teamStats: true,
  },
  {
    title: "FG%",
    showImage: false,
    sortable: true,
    key: "fg_pct",
    classList: ["shrink-column"],
  },
  {
    title: "SQ FG%",
    showImage: false,
    sortable: true,
    key: "sq_fg_pct",
    classList: ["shrink-column"],
    lock: true,
  },
  {
    title: "FG% Regression",
    showImage: false,
    sortable: true,
    key: "regression",
    classList: ["shrink-column"],
    lock: true,
    showArrow: true,
  },
  {
    title: "3P",
    showImage: false,
    sortable: false,
    key: "fg3_makes",
    classList: ["shrink-column"],
    teamStats: true,
  },
  {
    title: "3PA",
    showImage: false,
    sortable: false,
    key: "fg3_attempts",
    classList: ["shrink-column"],
    teamStats: true,
  },
  {
    title: "3P%",
    showImage: false,
    sortable: false,
    key: "fg3_pct",
    classList: ["shrink-column"],
  },
  {
    title: "3PT SQ FG%",
    showImage: false,
    sortable: false,
    key: "sq_fg3_pct",
    classList: ["shrink-column"],
  },
  {
    title: "3PT% Regression",
    showImage: false,
    sortable: false,
    key: "regression_3pt",
    classList: ["shrink-column"],
    showArrow: true,
  },
  {
    title: "MP",
    showImage: false,
    sortable: true,
    key: "mp",
    classList: ["shrink-column"],
  },
  {
    title: "FT",
    showImage: false,
    sortable: true,
    key: "ft_makes",
    classList: ["shrink-column"],
    teamStats: true,
  },
  {
    title: "FTA",
    showImage: false,
    sortable: true,
    key: "ft_attempts",
    classList: ["shrink-column"],
    teamStats: true,
  },
  {
    title: "FT%",
    showImage: false,
    sortable: true,
    key: "ft_pct",
    classList: ["shrink-column"],
  },
  {
    title: "ORB",
    showImage: false,
    sortable: true,
    key: "oreb",
    classList: ["shrink-column"],
    teamStats: true,
  },
  {
    title: "DRB",
    showImage: false,
    sortable: true,
    key: "dreb",
    classList: ["shrink-column"],
    teamStats: true,
  },
  {
    title: "TRB",
    showImage: false,
    sortable: true,
    key: "treb",
    classList: ["shrink-column"],
    teamStats: true,
  },
  {
    title: "AST",
    showImage: false,
    sortable: true,
    key: "ast",
    classList: ["shrink-column"],
    teamStats: true,
  },
  {
    title: "STL",
    showImage: false,
    sortable: true,
    key: "stl",
    classList: ["shrink-column"],
    teamStats: true,
  },
  {
    title: "BLK",
    showImage: false,
    sortable: true,
    key: "blk",
    classList: ["shrink-column"],
    teamStats: true,
  },
  {
    title: "TOV",
    showImage: false,
    sortable: true,
    key: "tov",
    classList: ["shrink-column"],
    teamStats: true,
  },
  {
    title: "PF",
    showImage: false,
    sortable: false,
    key: "pf",
    classList: ["shrink-column"],
    teamStats: true,
  },
  //add this to shot types
  // {
  //   title: "AT Rim FGA",
  //   showImage: false,
  //   sortable: true,
  //   key: "at_rim_attempts",
  //   classList: ["shrink-column"],
  // },
  // {
  //   title: "AT Rim FGM",
  //   showImage: false,
  //   sortable: true,
  //   key: "at_rim_makes",
  //   classList: ["shrink-column"],
  // },
  // {
  //   title: "Midrange FGA",
  //   showImage: false,
  //   sortable: true,
  //   key: "midrange_attempts",
  //   classList: ["shrink-column"],
  // },
  // {
  //   title: "Midrange FGM",
  //   showImage: false,
  //   sortable: true,
  //   key: "midrange_makes",
  //   classList: ["shrink-column"],
  // },
  // {
  //   title: "FG2M",
  //   showImage: false,
  //   sortable: true,
  //   key: "fg2_makes",
  //   classList: ["shrink-column"],
  // },
  // {
  //   title: "FG2A",
  //   showImage: false,
  //   sortable: false,
  //   key: "fg2_attempts",
  //   classList: ["shrink-column"],
  // },
  // {
  //   title: "FG2%",
  //   showImage: false,
  //   sortable: true,
  //   key: "fg2_pct",
  //   classList: ["shrink-column"],
  // },
  // {
  //   title: "SQ FG2%",
  //   showImage: false,
  //   sortable: false,
  //   key: "sq_fg2_pct",
  //   classList: ["shrink-column"],
  // },
  // {
  //   title: "Midrange FG%",
  //   showImage: false,
  //   sortable: true,
  //   key: "midrange_fg_pct",
  //   classList: ["shrink-column"],
  // },
  // {
  //   title: "Midrange SQ FG%",
  //   showImage: false,
  //   sortable: true,
  //   key: "midrange_sq_fg_pct",
  //   classList: ["shrink-column"],
  // },
  // {
  //   title: "AT Rim FG%",
  //   showImage: false,
  //   sortable: true,
  //   key: "at_rim_fg_pct",
  //   classList: ["shrink-column"],
  // },
  // {
  //   title: "AT Rim SQ FG%",
  //   showImage: false,
  //   sortable: false,
  //   key: "at_rim_sq_fg_pct",
  //   classList: ["shrink-column"],
  // },
  // {
  //   title: "Regression 2pt",
  //   showImage: false,
  //   sortable: false,
  //   key: "regression_2pt",
  //   classList: ["shrink-column"],
  //   showArrow: true,
  // },
  // {
  //   title: "Game ID",
  //   showImage: false,
  //   sortable: true,
  //   key: "game_id",
  //   classList: ["shrink-column"],
  // },
  // {
  //   title: "League",
  //   showImage: false,
  //   sortable: true,
  //   key: "league",
  //   classList: ["shrink-column"],
  // },
  // {
  //   title: "Round Name",
  //   showImage: false,
  //   sortable: true,
  //   key: "round_name",
  //   classList: ["shrink-column"],
  // },
  // {
  //   title: "Season",
  //   showImage: false,
  //   sortable: true,
  //   key: "season",
  //   classList: ["shrink-column"],
  // },

  // {
  //   title: "Date",
  //   showImage: false,
  //   sortable: true,
  //   key: "date",
  //   // classList: ["shrink-column"],
  // },
  // {
  //   title: "Team",
  //   showImage: false,
  //   sortable: true,
  //   key: "team",
  //   classList: ["shrink-column"],
  // },
  // {
  //   title: "Opp",
  //   showImage: false,
  //   sortable: false,
  //   key: "opponent",
  //   classList: ["shrink-column"],
  // },
];

export const Game = () => {
  const { store, setStore } = useContext(AppContext);
  const router = useRouter();
  const { league, gameReference, year } = router.query;
  let leagueType = league === "ncaa" ? "college_mens" : league === "ncaaw" ? "college_womens" : league;
  const [teamName, setTeamName] = useState(router.query?.teamName);
  const [authToken, setAuthToken] = useState();
  const [notFound, setNotFound] = useState(false);
  const [cookies, setCookie] = useCookies(["token_access, name"]);
  const [user, setUser] = useState(null);
  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("user")));
  }, []);

  const isStandardPlan = Utils.hasStandardPlan(user);
  const isPremiumPlan = Utils.hasPremiumPlan(user);
  const isPayed = isStandardPlan || isPremiumPlan;

  useEffect(() => {
    document.cookie.includes("token_access=") &&
      setAuthToken(document.cookie.split("token_access=").pop().split(";").shift());
  }, []);
  const [teamAScore, setTeamAScore] = useState(104);
  const [teamBScore, setTeamBScore] = useState(88);

  const [outliers, setOutliers] = useState("");
  const [teamARecord, setTeamARecord] = useState("19 - 14");
  const [teamBRecord, setTeamBRecord] = useState("30 - 5");
  const tempOpps = router.query?.gameReference.split(router.query?.teamName + " ");
  const [opponentName, setOpponentName] = useState(tempOpps.length > 1 ? tempOpps[1] : "");
  const [gameSummary, setGameSummary] = useState(null);
  const [teamAcolor, setTeamAColor] = useState("#9E1B32");
  const [teamBcolor, setTeamBColor] = useState("#0033A0");
  const [gameData, setGameData] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [searchAutocomplete, setSearchAutocomplete] = useState({
    team: [],
    player: [],
    description: [],
  });
  const [playLog, setPlayLog] = useState(PLAYLOG);
  const [luckDesc, setLuckDesc] = useState([
    "Alabama Were Expected to Score 13 Less Points on Finishes at the Rim",
    "South Dakota St. Were Expected to Score 12 More Points on Three Pointers",
    "South Dakota St. Were Expected to Score 3 More Points on Free Throws",
    "South Dakota St. Were Expected to Play 11% Better Offensively",
    "Baylor Scheierman Was Expected to Score 8 More Points",
    "South Dakota St. Were Expected to Score 7 Less Points on Finishes at the Rim",
  ]);
  const [isluckDescLoaded, setIsLuckDescLoaded] = useState(false);
  const [playerGameLog, setPlayerGameLog] = useState({});
  //DISABLED FOR DUMMY DATA
  useEffect(() => {
    setStore({ ...store, leagueType });

    // DISABLED FOR DUMMY DATA
    if (authToken) {
      if (!(leagueType === "nba" && year === "2020")) {
        authGetRequest(`/api/${leagueType}/${year}/games/${teamName}/${gameReference}/luck_description`, authToken)
          .then((res) => res.data)
          .then((response) => {
            let data = response.data;
            if (data) {
              let sentences = [];
              Object.keys(data[0]).map((ky) => {
                if (ky.startsWith("Type_")) {
                  if (data[0][ky]) {
                    sentences.push(data[0][ky]);
                  }
                }
              });
              setLuckDesc(sentences);
              setIsLuckDescLoaded(true);
            }
          })
          .catch(async (err) => {
            if (err.message.includes("401") && isPremiumPlan) {
              try {
                const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
                  method: "POST",
                  headers: {
                    Authorization: `Bearer ${authToken}`,
                  },
                  body: authToken,
                })
                  .then((res) => res.json())
                  .then((response) => {
                    if (response.access_token) {
                      setCookie("token_access", response.access_token);
                      setAuthToken(response.access_token);
                    }
                  });
              } catch (error) {
                console.log(error);
              }
            }
            setNotFound(true);

            console.log(err);
          });
      } else {
        setIsLuckDescLoaded(true);
      }
    }

    async function load() {
      const responses = await Promise.all([
        // DISABLED FOR DUMMY DATA
        authGetRequest(`/api/${leagueType}/${year}/games/${teamName}/${gameReference}/summary`, authToken)
          .then((res) => res.data)
          .then((response) => {
            if (response.data) {
              setTeamName(response.data[0].Teams);
              setTeamAScore(response.data[0].Scores);
              setTeamBScore(response.data[1].Scores);
              setTeamARecord(response.data[0].Records);
              setTeamBRecord(response.data[1].Records);
              setOpponentName(response.data[1].Teams);
              setGameSummary(response.data);
              Utils.readCsv("teams/Color_Code_for_Teams.csv").then((colorCSV) => {
                setTeamBColor(colorCSV.filter((x) => x.Teams == response.data[1].Teams)[0]?.Colors);
                setTeamAColor(colorCSV.filter((x) => x.Teams == response.data[0].Teams)[0]?.Colors);
              });
              return response;
            }
          })
          .catch(async (err) => {
            if (err.message.includes("401") && isPremiumPlan) {
              try {
                const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
                  method: "POST",
                  headers: {
                    Authorization: `Bearer ${authToken}`,
                  },
                  body: authToken,
                })
                  .then((res) => res.json())
                  .then((response) => {
                    if (response.access_token) {
                      setCookie("token_access", response.access_token);
                      setAuthToken(response.access_token);
                    }
                  });
              } catch (error) {
                console.log(error);
              }
            }
            setNotFound(true);
          }),
        authGetRequest(`/api/${leagueType}/${year}/games/${gameReference}/outliers`, authToken)
          .then((res) => res.data)
          .then((response) => {
            if (response.data) {
              setOutliers(response.data);
              return response;
            }
          })
          .catch(async (err) => {
            if (err.message.includes("401") && isPremiumPlan) {
              try {
                const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
                  method: "POST",
                  headers: {
                    Authorization: `Bearer ${authToken}`,
                  },
                  body: authToken,
                })
                  .then((res) => res.json())
                  .then((response) => {
                    if (response.access_token) {
                      setCookie("token_access", response.access_token);
                      setAuthToken(response.access_token);
                    }
                  });
              } catch (error) {
                console.log(error);
              }
            }
            setNotFound(true);
          }),
      ]);
    }
    if (authToken) {
      load();
    }
  }, [authToken]);

  useEffect(() => {
    if (authToken && gameSummary && gameSummary.length > 0 && gameSummary[0].game_id) {
      authGetRequest(`/api/${leagueType}/${gameSummary[0].game_id}/player-gamelogs`, authToken)
        .then((res) => res.data)
        .then((response) => {
          if (response.data) {
            const tempGameLogs = response.data.map((it) => {
              return { ...it, pts_regression: it.sq_pts - it.pts };
            });
            const homeTeamGameLog = tempGameLogs.filter((it) => it.team === teamName);
            const awayTeamGameLog = tempGameLogs.filter((it) => it.team === opponentName);
            const homeGameLogWithTeamStats = {};
            const awayGameLogWithTeamStats = {};
            homeTeamGameLog.forEach((it) => {
              gameLogHeader.forEach((header) => {
                if (header.teamStats) {
                  homeGameLogWithTeamStats[header.key] = (homeGameLogWithTeamStats[header.key] || 0) + it[header.key];
                } else if (header.key === "player") {
                  homeGameLogWithTeamStats[header.key] = "Team";
                } else {
                  homeGameLogWithTeamStats[header.key] = null;
                }
              });
            });
            // homeTeamGameLog.push(homeGameLogWithTeamStats);

            awayTeamGameLog.forEach((it) => {
              gameLogHeader.forEach((header) => {
                if (header.teamStats) {
                  awayGameLogWithTeamStats[header.key] = (awayGameLogWithTeamStats[header.key] || 0) + it[header.key];
                } else if (header.key === "player") {
                  awayGameLogWithTeamStats[header.key] = "Team";
                } else {
                  awayGameLogWithTeamStats[header.key] = null;
                }
              });
            });
            // awayTeamGameLog.push(awayGameLogWithTeamStats);

            setPlayerGameLog({
              home: homeTeamGameLog,
              away: awayTeamGameLog,
              homeTeamStats: homeGameLogWithTeamStats,
              awayTeamStats: awayGameLogWithTeamStats,
            });
          }
        })
        .catch(async (err) => {
          console.error(err);
          setNotFound(true);
        });

      fetch(`https://embed.shotquality.com/data/betting?gid=${gameSummary[0].game_id}`)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data && data.game_info) {
            const { home_team, away_team, game_time } = data.game_info;
            const formattedDate = game_time?.split(" ")[0] || "";
            setGameData(data);
          }
        });
    }
  }, [gameSummary, authToken, leagueType, teamName, opponentName]);
  useEffect(() => {
    if (luckDesc.length > 0) {
      setIsLuckDescLoaded(true);
    }
  }, [luckDesc]);

  const getImage = (name) => {
    return `/static/media/percentile/graph—${name}.png`;
  };

  const searchByTeam = (searchTerm) => {
    return Array.from(
      new Set(
        playLog.filter((log) => log["Team"].toLowerCase().includes(searchTerm.toLowerCase())).map((log) => log["Team"])
      )
    );
  };

  const searchByPlayerName = (searchTerm) => {
    return Array.from(
      new Set(
        playLog
          .filter((log) => log["Players"].toLowerCase().includes(searchTerm.toLowerCase()))
          .map((log) => log["Players"])
      )
    );
  };

  const searchByPlayerDesc = (searchTerm) => {
    return year === "2021"
      ? Array.from(
          new Set(
            playLog
              .filter((log) => log["Play_run"].toLowerCase().includes(searchTerm.toLowerCase()))
              .map((log) => log["Play_run"])
          )
        )
      : [];
  };

  useEffect(() => {
    setSearchAutocomplete({
      team: searchByTeam(searchKey).splice(0, 5),
      players: searchByPlayerName(searchKey).splice(0, 5),
      description: searchByPlayerDesc(searchKey).splice(0, 5),
    });
  }, [searchKey, setSearchKey]);

  const handlePlayLogExportClick = (e) => {
    e.preventDefault();
    const modifiedPlayLog = [];

    if (year === "2020") {
      playLog.forEach((log) => {
        modifiedPlayLog.push({
          Minutes: log["Minutes"],
          Seconds: log["Seconds"],
          Period: log["Period"],
          Team: log["Team"],
          Players: log["Players"],
          "Possession Quality": log["Possession_Quality"],
          "SQ Points": log["SQ_Points"],
          "SQ Points Rank": log["SQ_Points_percentile"],
        });
      });
      Utils.jsonToCsv(modifiedPlayLog);
    }

    if (year === "2021") {
      playLog.forEach((log) => {
        modifiedPlayLog.push({
          Minutes: log["Minutes"],
          Seconds: log["Seconds"],
          Period: log["Period"],
          Team: log["Team"],
          "Player Description": `${log["Players"] || ""} ${log["Play_run"] || ""}`,
          "Possession Quality": log["Possession_Quality"],
          "SQ Points": log["SQ_Points"],
          "SQ Points Rank": log["SQ_Points_percentile"],
        });
      });

      Utils.jsonToCsv(modifiedPlayLog);
    }
  };

  return (
    <main id="ContentBox" style={{ position: "relative" }}>
      <Head>
        {user ? (
          <title>{`${teamName} vs ${opponentName} Basketball Score, Predictions & Schedule | ShotQuality Bets`}</title>
        ) : (
          <title>Basketball Score, Predictions & Schedule | ShotQuality Bets</title>
        )}

        <meta
          property="description"
          content={`View odds, predictions, free picks, spread bets, and game totals for ${teamName} vs ${opponentName} ${league} basketball
          games for the entire ${getDefYear(leagueType)} season. Unlock the most valuable dataset in NCAA basketball.`}
        />
      </Head>
      {notFound ? (
        <NotFound />
      ) : (
        <>
          {user && (!user.has_paid || !isPayed) && (
            <div
              style={{
                top: "5%",
                bottom: "auto",
                height: "100%",
                position: "absolute",
                background: "linear-gradient(180deg,rgba(2,0,36,0),#fff 80%)",
                backdropFilter: "blur(5px)",
                left: 0,
                right: 0,
                zIndex: 50,
                display: "flex",
                justifyContent: "center",
                paddingBottom: "100px",
                inset: "0% 0px auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  flexDirection: "column",
                  marginTop: "15%",
                }}
              >
                <h3>This is premium content</h3>
                <p>{SIGNUPS_CLOSED_MESSAGE}</p>
              </div>
            </div>
          )}
          <div className="Dukeside text-center">
            <div className="container pt-5">
              <div className="row">
                {[teamName, opponentName, teamARecord, teamBRecord].every((elem) =>
                  elem && elem?.length > 0 ? true : false
                ) === true ? (
                  <>
                    <div className="box col-sm-6 text-sm-right">
                      <div className="d-inline-block text-center">
                        <Link href={`/team/${leagueType}/${year}/${teamName || ""}`}>
                          <h2 style={{ color: teamAcolor }}>
                            <img
                              style={{ height: "auto" }}
                              src={`/static/media/logos/${teamName && teamName.replace("/", "-")}.png`}
                              alt={teamName}
                            />{" "}
                            {teamName}
                            <span style={{ marginLeft: 10, color: "#000" }}>: {teamAScore}</span>
                          </h2>
                          <span className="level d-block">{teamARecord}</span>
                        </Link>
                      </div>
                    </div>
                    <div className="box col-sm-6 text-sm-left">
                      <div className="d-inline-block text-center">
                        <Link href={`/team/${leagueType}/${year}/${opponentName || ""}`}>
                          <h2 style={{ color: teamBcolor }}>
                            <img
                              style={{ height: "auto" }}
                              src={`/static/media/logos/${opponentName && opponentName.replace("/", "-")}.png`}
                              alt={opponentName}
                            />{" "}
                            {opponentName}
                            <span style={{ marginLeft: 10, color: "#000" }}>: {teamBScore}</span>
                          </h2>
                          <span className="level d-block">{teamBRecord}</span>
                        </Link>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="col-sm-12">
                    <LoadingSkeleton variant="header" width="80%" height="80px" />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="Scoreside text-center">
            <div className="container-fluid mt-3">
              <div className="based">
                {gameSummary && [teamName, opponentName, gameSummary].every((elem) => elem && elem?.length > 0) ? (
                  outliers.split("\n").map((i, key) => {
                    return (
                      <p className="mt-2" key={key} style={{ fontSize: 24, borderRadius: "5px" }}>
                        {i}
                      </p>
                    );
                  })
                ) : (
                  <LoadingSkeleton variant="primary" height="116px" />
                )}
              </div>
              <div className="finalscroe">
                <h2>FINAL SCORE</h2>

                {gameData ? (
                  <BoxScores data={gameData} league={league} />
                ) : (
                  <div className="row justify-content-center">
                    <div className="col-lg-6">
                      {gameSummary && gameSummary.length > 0 ? (
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr>
                                <TableHeader headers={finalScoreHeader} />
                              </tr>
                            </thead>
                            <tbody>
                              {gameSummary.map((data) => (
                                <tr key={data.Teams}>
                                  <td>
                                    <Image
                                      height={60}
                                      width={60}
                                      src={`/static/media/logos/${data.Teams && data.Teams.replace("/", "-")}.png`}
                                      alt={data.Teams}
                                    />
                                  </td>
                                  <td>{data.Scores}</td>
                                  <td>{data["xPOINTS"].toFixed(2)}</td>
                                  <td>{data["xPPP"].toFixed(2)}</td>
                                  <td>
                                    <Image
                                      height={60}
                                      width={60}
                                      src={getImage(Math.round(data["OVERALL_SHOT_QUALITY_GRAPH"] * 100))}
                                      alt=""
                                      className="scoregraph"
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <TableSkeleton tableRowsCount={2} tableHeader={finalScoreHeader} />
                      )}
                    </div>
                  </div>
                )}
              </div>
              {playerGameLog?.home?.length > 0 && (
                <div className="row game-page-box-scores">
                  <div className="col-12">
                    <h2 className="text-center color-orange fw-9 fs-48 mt-5">BOXSCORE</h2>
                    <TableData data={playerGameLog.home} header={gameLogHeader} user={user} tableTitle={teamName}>
                      <TableRow
                        data={playerGameLog.homeTeamStats}
                        header={gameLogHeader}
                        user={user}
                        isPaid={user?.has_paid}
                        league={league}
                      />
                    </TableData>
                  </div>
                  <div className="col-12">
                    <TableData data={playerGameLog.away} header={gameLogHeader} user={user} tableTitle={opponentName}>
                      <TableRow
                        data={playerGameLog.awayTeamStats}
                        header={gameLogHeader}
                        user={user}
                        isPaid={user?.has_paid}
                        league={league}
                      />
                    </TableData>
                  </div>
                </div>
              )}
              {isluckDescLoaded
                ? luckDesc.length > 0 && (
                    <section className="mt-5">
                      <div className="container p-0">
                        <div className="row align-items-center">
                          <div className="col-sm-12">
                            <div className="Titleside pl-3">
                              <div className="box">
                                <h2 className="m-0">Luck Description (Based on Quality of Shots Taken)</h2>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          {luckDesc.map((sentence, i) => {
                            let splitSentences = [];
                            for (const word of ["Score", "Play", "Expected"]) {
                              splitSentences = sentence.split(word);
                              if (splitSentences.length > 1) {
                                splitSentences.splice(1, 0, word);
                                break;
                              }
                            }
                            return (
                              <div
                                className="col-12 col-md-4"
                                key={`${sentence}`}
                                style={{
                                  animation: "fade-in .5s ease-in-out forwards",
                                  animationDelay: `${i * 0.075}s`,
                                  padding: ".5rem",
                                }}
                              >
                                <div
                                  className="box-shadow-1"
                                  style={{
                                    borderRadius: "10px",
                                    padding: "1rem 2rem",
                                    color: "#000",
                                  }}
                                >
                                  <p className="m-0">
                                    {splitSentences[0] ?? ""} {splitSentences[1] ?? ""}{" "}
                                  </p>
                                  <h6 className="text-dark">{splitSentences[2] ?? ""}</h6>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </section>
                  )
                : null}
            </div>
          </div>

          {!user && (
            <div
              style={{
                top: "5%",
                bottom: "auto",
                height: "100%",
                position: "absolute",
                background: "linear-gradient(180deg,rgba(2,0,36,0),#fff 80%)",
                backdropFilter: "blur(6px)",
                left: 0,
                right: 0,
                zIndex: 50,
                display: "flex",
                justifyContent: "center",
                paddingBottom: "100px",
                inset: "0% 0px auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  paddingTop: "200px",
                }}
              >
                <h3>Sign in to See More</h3>
                <div style={{ width: "40%", color: "#6B6C72" }}>
                  The Shot Quality Betting Model is a proven betting system. Using advanced predictive data, it returned
                  a 53.5% win rate and $6200 to a $100 bettor last season.
                </div>
                <Link href={"/login"}>
                  <button className="btn btn-dummy btn-lg min-width-236px">Sign in</button>
                </Link>
                <div
                  style={{
                    display: "flex",
                    fontSize: 18,
                    fontWeight: 600,
                    flexDirection: "row",
                    marginTop: 40,
                  }}
                >
                  <div
                    style={{
                      color: "#0F131B",
                      fontSize: 18,
                      fontWeight: 600,
                      flexDirection: "row",
                    }}
                  >
                    Already have an account?
                  </div>
                  <Link href={"/login#login"} onClick={Utils.setPreLoginUrl}>
                    <div
                      style={{
                        color: "#F26B0B",
                        marginLeft: 10,
                        textDecoration: "underline",
                      }}
                    >
                      Sign In
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </main>
  );
};
